export default function useSearchApi() {
  const baseURL = '/search-api/v1/'
  const context = useSearchContext()

  async function search(query: SearchApiParams) {
    const season = useSearchSeason(query)

    return await useFetch('engines/accomtrips', {
      baseURL,
      params: {
        language: context.language,
        currency: context.currency,
        salesoffice: context.salesOfficeCode,
        freeweek: context.isFreeweek || undefined,
        season: season.value,
        ...mapSearchApiParams(query),
      },
      transform(result: SearchApiResult) {
        return mapSearchResult(context, result, query)
      },
    })
  }

  async function getLinkedObjects(code: string, language?: string) {
    return $fetch<SearchResult>(`accoms/${code}/linked-objects`, {
      baseURL,
      headers: removeFalsy({ 'Accept-Language': language }),
    })
  }

  return { search, getLinkedObjects }
}
